<template>
    <div>
        <el-form-item :class="required" :label="field['label-show'] === false ? '' : (field.name + '：')" label-width="110px">
            <el-input clearable v-model="config[field.key]" :placeholder="'请输入' + field.name" :maxlength="field.max"></el-input>
            <p class="memo" v-if="field.memo">{{field.memo}}</p>
        </el-form-item>
    </div>
</template>

<style lang="scss" scoped>
    .el-form-item {
        /*margin-bottom: 5px;*/
    }

    .memo {
        color: #C5C5C5;
        line-height: 30px;
        margin-bottom: 0px;
        font-size: 14px;
    }
</style>

<script>

  export default {
    name: 'tms-type-text',
    props: {
      field: {
        type: [Object, Array],
        required: true
      },
      // config: {
      //   type: Object,
      //   default() {
      //     return {}
      //   }
      // },
      source: {
        type: String,
      }
    },

    computed: {
      required() {
        if (this.field.required) {
          return 'is-required'
        } else {
          return '';
        }
      },
      config() {
        if (this.source === 'tmsPageConfig') {
          return this.$store.state.tms.pageData
        }
        if (this.source === 'tmsModuleConfig') {
          return this.$store.state.tms.config;
        }
        return this.$store.state.tms.customConfig;
      }
    },
    data() {
      return {

      }
    },

    created() {
    },

    components: {},

    mounted() {

    },

    methods: {}
  }

</script>
